"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientEvents = exports.ClientEvent = void 0;
var ClientEvent;
(function (ClientEvent) {
    ClientEvent["CLIENT_DISCONNECT"] = "client-disconnect";
    ClientEvent["CLIENT_DISCONNECTED"] = "client-disconnected";
    ClientEvent["CLIENT_INIT"] = "client-init";
    ClientEvent["B2C_CLIENT_INIT"] = "b2c-client-init";
    ClientEvent["B2C_CLIENT_UPDATE"] = "b2c-client-update";
    ClientEvent["CLIENT_NOTIFICATION"] = "client-notification";
    ClientEvent["CLIENT_PING"] = "client-ping";
    ClientEvent["CLIENT_PONG"] = "client-pong";
    ClientEvent["CLIENT_GET_CURRENCIES_REQ"] = "client-get-currencies-req";
    ClientEvent["CLIENT_GET_CURRENCIES_RES"] = "client-get-currencies-res";
    ClientEvent["CLIENT_GET_SUPPORT_REQ"] = "client-get-support-req";
    ClientEvent["CLIENT_GET_SUPPORT_RES"] = "client-get-support-res";
    ClientEvent["CLIENT_GET_PLAYER_WALLET_REQ"] = "client-get-player-wallet-req";
    ClientEvent["CLIENT_GET_PLAYER_WALLET_RES"] = "client-get-player-wallet-res";
    ClientEvent["CLIENT_GET_BETS_REQ"] = "client-get-bets-req";
    ClientEvent["CLIENT_GET_BETS_RES"] = "client-get-bets-res";
    ClientEvent["CLIENT_GET_TRANSACTIONS_REQ"] = "client-get-transactions-req";
    ClientEvent["CLIENT_GET_TRANSACTIONS_RES"] = "client-get-transactions-res";
    ClientEvent["CLIENT_GET_PAYMENT_URL_REQ"] = "client-get-payment-url-req";
    ClientEvent["CLIENT_GET_PAYMENT_URL_RES"] = "client-get-payment-url-res";
    ClientEvent["CLIENT_GET_UPLOAD_URL_REQ"] = "client-get-upload-url-req";
    ClientEvent["CLIENT_GET_UPLOAD_URL_RES"] = "client-get-upload-url-res";
    ClientEvent["CLIENT_GET_CHAT_CONNECTION_INFO_REQ"] = "client-get-chat-connection-info-req";
    ClientEvent["CLIENT_GET_CHAT_CONNECTION_INFO_RES"] = "client-get-chat-connection-info-res";
    ClientEvent["CLIENT_VERIFY_PAYMENT_REQ"] = "client-verify-payment-req";
    ClientEvent["CLIENT_VERIFY_PAYMENT_RES"] = "client-verify-payment-res";
    ClientEvent["CLIENT_GET_GAME_LAUNCH_REQ"] = "client-get-game-launch-req";
    ClientEvent["CLIENT_GET_GAME_LAUNCH_RES"] = "client-get-game-launch-res";
    ClientEvent["CLIENT_SET_ACTIVE_CURRENCY_REQ"] = "client-set-active-currency-req";
    ClientEvent["CLIENT_SET_ACTIVE_CURRENCY_RES"] = "client-set-active-currency-res";
    ClientEvent["CLIENT_SET_ACTIVE_LANGUAGE_REQ"] = "client-set-active-language-req";
    ClientEvent["CLIENT_SET_ACTIVE_LANGUAGE_RES"] = "client-set-active-language-res";
    ClientEvent["CLIENT_CLOSE_GAME_REQ"] = "client-close-game-req";
    ClientEvent["CLIENT_CLOSE_GAME_RES"] = "client-close-game-res";
    ClientEvent["CLIENT_SET_UI_STATE_REQ"] = "client-set-ui-state-req";
    ClientEvent["CLIENT_SET_UI_STATE_RES"] = "client-set-ui-state-res";
    ClientEvent["CLIENT_GET_UI_STATE_REQ"] = "client-get-ui-state-req";
    ClientEvent["CLIENT_GET_UI_STATE_RES"] = "client-get-ui-state-res";
    ClientEvent["CLIENT_ADD_CPG_WITHDRAW_REQ"] = "client-add-cpg-withdraw-req";
    ClientEvent["CLIENT_ADD_CPG_WITHDRAW_RES"] = "client-add-cpg-withdraw-res";
    ClientEvent["CLIENT_ADD_PW_WITHDRAW_REQ"] = "client-add-pw-withdraw-req";
    ClientEvent["CLIENT_ADD_PW_WITHDRAW_RES"] = "client-add-pw-withdraw-res";
    ClientEvent["CLIENT_GET_PM_WITHDRAW_CALCULATIONS_REQ"] = "client-get-pm-withdraw-calculations-req";
    ClientEvent["CLIENT_GET_PM_WITHDRAW_CALCULATIONS_RES"] = "client-get-pm-withdraw-calculations-res";
    ClientEvent["CLIENT_ADD_PM_WITHDRAW_REQ"] = "client-add-pm-withdraw-req";
    ClientEvent["CLIENT_ADD_PM_WITHDRAW_RES"] = "client-add-pm-withdraw-res";
    ClientEvent["CLIENT_ADD_PM_VOUCHER_DEPOSIT_REQ"] = "client-add-pm-voucher-deposit-req";
    ClientEvent["CLIENT_ADD_PM_VOUCHER_DEPOSIT_RES"] = "client-add-pm-voucher-deposit-res";
    ClientEvent["CLIENT_ADD_JB_WITHDRAW_REQ"] = "client-add-jb-withdraw-req";
    ClientEvent["CLIENT_ADD_JB_WITHDRAW_RES"] = "client-add-jb-withdraw-res";
    ClientEvent["CLIENT_CANCEL_WITHDRAW_REQ"] = "client-cancel-withdraw-req";
    ClientEvent["CLIENT_CANCEL_WITHDRAW_RES"] = "client-cancel-withdraw-res";
    ClientEvent["CLIENT_ADD_KYC_VERIFICATION_FILE_REQ"] = "client-add-kyc-verification-file-req";
    ClientEvent["CLIENT_ADD_KYC_VERIFICATION_FILE_RES"] = "client-add-kyc-verification-file-res";
    ClientEvent["CLIENT_DELETE_KYC_VERIFICATION_FILE_REQ"] = "client-delete-kyc-verification-file-req";
    ClientEvent["CLIENT_DELETE_KYC_VERIFICATION_FILE_RES"] = "client-delete-kyc-verification-file-res";
    ClientEvent["CLIENT_PLAYER_NICKNAME_CHANGE"] = "client-player-nickname-change";
    ClientEvent["CLIENT_GET_B2C_TRANSACTIONS_REQ"] = "client-get-b2c-transactions-req";
    ClientEvent["CLIENT_GET_B2C_TRANSACTIONS_RES"] = "client-get-b2c-transactions-res";
    ClientEvent["CLIENT_GET_B2C_BETS_REQ"] = "client-get-b2c-bets-req";
    ClientEvent["CLIENT_GET_B2C_BETS_RES"] = "client-get-b2c-bets-res";
    ClientEvent["CLIENT_Add_B2C_CRYPTO_DEPOSIT_REQ"] = "client-add-b2c-crypto-deposit-req";
    ClientEvent["CLIENT_Add_B2C_CRYPTO_DEPOSIT_RES"] = "client-add-b2c-crypto-deposit-res";
    ClientEvent["CLIENT_Add_B2C_CRYPTO_CHECK_REQ"] = "client-add-b2c-crypto-check-req";
    ClientEvent["CLIENT_Add_B2C_CRYPTO_CHECK_RES"] = "client-add-b2c-crypto-check-res";
    ClientEvent["CLIENT_Add_B2C_CRYPTO_WITHDRAW_REQ"] = "client-add-b2c-crypto-withdraw-req";
    ClientEvent["CLIENT_Add_B2C_CRYPTO_WITHDRAW_RES"] = "client-add-b2c-crypto-withdraw-res";
    ClientEvent["CLIENT_Add_B2C_MINI_PAY_DEPOSIT_REQ"] = "client-add-b2c-mini-pay-deposit-req";
    ClientEvent["CLIENT_Add_B2C_MINI_PAY_DEPOSIT_RES"] = "client-add-b2c-mini-pay-deposit-res";
    ClientEvent["CLIENT_Add_B2C_MINI_PAY_WITHDRAW_REQ"] = "client-add-b2c-mini-pay-withdraw-req";
    ClientEvent["CLIENT_Add_B2C_MINI_PAY_WITHDRAW_RES"] = "client-add-b2c-mini-pay-withdraw-res";
    ClientEvent["CLIENT_PLAYER_EXTRA_DATA_CHANGE"] = "client-player-extra-data-change";
})(ClientEvent || (exports.ClientEvent = ClientEvent = {}));
class ClientEvents {
}
exports.ClientEvents = ClientEvents;
ClientEvents.disconnect = ClientEvent.CLIENT_DISCONNECT;
ClientEvents.disconnected = ClientEvent.CLIENT_DISCONNECTED;
ClientEvents.init = ClientEvent.CLIENT_INIT;
ClientEvents.notification = ClientEvent.CLIENT_NOTIFICATION;
ClientEvents.ping = ClientEvent.CLIENT_PING;
ClientEvents.pong = ClientEvent.CLIENT_PONG;
ClientEvents.b2cInit = ClientEvent.B2C_CLIENT_INIT;
ClientEvents.b2cUpdate = ClientEvent.B2C_CLIENT_UPDATE;
ClientEvents.getCurrenciesRequest = ClientEvent.CLIENT_GET_CURRENCIES_REQ;
ClientEvents.getCurrenciesResponse = ClientEvent.CLIENT_GET_CURRENCIES_RES;
ClientEvents.getSupportRequest = ClientEvent.CLIENT_GET_SUPPORT_REQ;
ClientEvents.getSupportResponse = ClientEvent.CLIENT_GET_SUPPORT_RES;
ClientEvents.getPlayerWalletRequest = ClientEvent.CLIENT_GET_PLAYER_WALLET_REQ;
ClientEvents.getPlayerWalletResponse = ClientEvent.CLIENT_GET_PLAYER_WALLET_RES;
ClientEvents.getBetsRequest = ClientEvent.CLIENT_GET_BETS_REQ;
ClientEvents.getBetsResponse = ClientEvent.CLIENT_GET_BETS_RES;
ClientEvents.getTransactionsRequest = ClientEvent.CLIENT_GET_TRANSACTIONS_REQ;
ClientEvents.getTransactionsResponse = ClientEvent.CLIENT_GET_TRANSACTIONS_RES;
ClientEvents.getPaymentUrlRequest = ClientEvent.CLIENT_GET_PAYMENT_URL_REQ;
ClientEvents.getPaymentUrlResponse = ClientEvent.CLIENT_GET_PAYMENT_URL_RES;
ClientEvents.getUploadUrlRequest = ClientEvent.CLIENT_GET_UPLOAD_URL_REQ;
ClientEvents.getUploadUrlResponse = ClientEvent.CLIENT_GET_UPLOAD_URL_RES;
ClientEvents.getChatConnectionInfoRequest = ClientEvent.CLIENT_GET_CHAT_CONNECTION_INFO_REQ;
ClientEvents.getChatConnectionInfoResponse = ClientEvent.CLIENT_GET_CHAT_CONNECTION_INFO_RES;
ClientEvents.verifyPaymentRequest = ClientEvent.CLIENT_VERIFY_PAYMENT_REQ;
ClientEvents.verifyPaymentResponse = ClientEvent.CLIENT_VERIFY_PAYMENT_RES;
ClientEvents.getGameLaunchRequest = ClientEvent.CLIENT_GET_GAME_LAUNCH_REQ;
ClientEvents.getGameLaunchResponse = ClientEvent.CLIENT_GET_GAME_LAUNCH_RES;
ClientEvents.setActiveCurrencyRequest = ClientEvent.CLIENT_SET_ACTIVE_CURRENCY_REQ;
ClientEvents.setActiveCurrencyResponse = ClientEvent.CLIENT_SET_ACTIVE_CURRENCY_RES;
ClientEvents.setActiveLanguageRequest = ClientEvent.CLIENT_SET_ACTIVE_LANGUAGE_REQ;
ClientEvents.setActiveLanguageResponse = ClientEvent.CLIENT_SET_ACTIVE_LANGUAGE_RES;
ClientEvents.closeGameRequest = ClientEvent.CLIENT_CLOSE_GAME_REQ;
ClientEvents.closeGameResponse = ClientEvent.CLIENT_CLOSE_GAME_RES;
ClientEvents.setUiStateRequest = ClientEvent.CLIENT_SET_UI_STATE_REQ;
ClientEvents.setUiStateResponse = ClientEvent.CLIENT_SET_UI_STATE_RES;
ClientEvents.getUiStateRequest = ClientEvent.CLIENT_GET_UI_STATE_REQ;
ClientEvents.getUiStateResponse = ClientEvent.CLIENT_GET_UI_STATE_RES;
ClientEvents.addCpgWithdrawRequest = ClientEvent.CLIENT_ADD_CPG_WITHDRAW_REQ;
ClientEvents.addCpgWithdrawResponse = ClientEvent.CLIENT_ADD_CPG_WITHDRAW_RES;
ClientEvents.addPwWithdrawRequest = ClientEvent.CLIENT_ADD_PW_WITHDRAW_REQ;
ClientEvents.addPwWithdrawResponse = ClientEvent.CLIENT_ADD_PW_WITHDRAW_RES;
ClientEvents.addJbWithdrawRequest = ClientEvent.CLIENT_ADD_JB_WITHDRAW_REQ;
ClientEvents.addJbWithdrawResponse = ClientEvent.CLIENT_ADD_JB_WITHDRAW_RES;
ClientEvents.getPmWithdrawCalculationsRequest = ClientEvent.CLIENT_GET_PM_WITHDRAW_CALCULATIONS_REQ;
ClientEvents.getPmWithdrawCalculationsResponse = ClientEvent.CLIENT_GET_PM_WITHDRAW_CALCULATIONS_RES;
ClientEvents.cancelWithdrawRequest = ClientEvent.CLIENT_CANCEL_WITHDRAW_REQ;
ClientEvents.cancelWithdrawResponse = ClientEvent.CLIENT_CANCEL_WITHDRAW_RES;
ClientEvents.addKycVerificationFileRequest = ClientEvent.CLIENT_ADD_KYC_VERIFICATION_FILE_REQ;
ClientEvents.addKycVerificationFileResponse = ClientEvent.CLIENT_ADD_KYC_VERIFICATION_FILE_RES;
ClientEvents.deleteKycVerificationFileRequest = ClientEvent.CLIENT_DELETE_KYC_VERIFICATION_FILE_REQ;
ClientEvents.deleteKycVerificationFileResponse = ClientEvent.CLIENT_DELETE_KYC_VERIFICATION_FILE_RES;
ClientEvents.playerNicknameChange = ClientEvent.CLIENT_PLAYER_NICKNAME_CHANGE;
ClientEvents.getB2cTransactionsRequest = ClientEvent.CLIENT_GET_B2C_TRANSACTIONS_REQ;
ClientEvents.getB2cTransactionsResponse = ClientEvent.CLIENT_GET_B2C_TRANSACTIONS_RES;
ClientEvents.addPmWithdrawRequest = ClientEvent.CLIENT_ADD_PM_WITHDRAW_REQ;
ClientEvents.addPmWithdrawResponse = ClientEvent.CLIENT_ADD_PM_WITHDRAW_RES;
ClientEvents.addPmVoucherDepositRequest = ClientEvent.CLIENT_ADD_PM_VOUCHER_DEPOSIT_REQ;
ClientEvents.addPmVoucherDepositResponse = ClientEvent.CLIENT_ADD_PM_VOUCHER_DEPOSIT_RES;
ClientEvents.getB2cBetsRequest = ClientEvent.CLIENT_GET_B2C_BETS_REQ;
ClientEvents.getB2cBetsResponse = ClientEvent.CLIENT_GET_B2C_BETS_RES;
ClientEvents.addB2cCryptoDepositRequest = ClientEvent.CLIENT_Add_B2C_CRYPTO_DEPOSIT_REQ;
ClientEvents.addB2cCryptoDepositResponse = ClientEvent.CLIENT_Add_B2C_CRYPTO_DEPOSIT_RES;
ClientEvents.addB2cCryptoWithdrawRequest = ClientEvent.CLIENT_Add_B2C_CRYPTO_WITHDRAW_REQ;
ClientEvents.addB2cCryptoWithdrawResponse = ClientEvent.CLIENT_Add_B2C_CRYPTO_WITHDRAW_RES;
ClientEvents.addB2cCryptoCheckRequest = ClientEvent.CLIENT_Add_B2C_CRYPTO_CHECK_REQ;
ClientEvents.addB2cCryptoCheckResponse = ClientEvent.CLIENT_Add_B2C_CRYPTO_CHECK_RES;
ClientEvents.addB2cMiniPayDepositRequest = ClientEvent.CLIENT_Add_B2C_MINI_PAY_DEPOSIT_REQ;
ClientEvents.addB2cMiniPayDepositResponse = ClientEvent.CLIENT_Add_B2C_MINI_PAY_DEPOSIT_RES;
ClientEvents.addB2cMiniPayWithdrawRequest = ClientEvent.CLIENT_Add_B2C_MINI_PAY_WITHDRAW_REQ;
ClientEvents.addB2cMiniPayWithdrawResponse = ClientEvent.CLIENT_Add_B2C_MINI_PAY_WITHDRAW_RES;
ClientEvents.playerExtraDataChange = ClientEvent.CLIENT_PLAYER_EXTRA_DATA_CHANGE;
